import { ConfigsInfo } from '../context/configs_context'
import { AccountApiData, parseAccount, parseRule, RuleApiData } from './account'
import { BranchApiData, parseBranch } from './branch'
import { CashierApiData, parseCashier } from './cashier'
import { CoinApiData, parseCoin } from './coin'
import {
    ConfigsApiData,
    ContactTypeApiData,
    parseConfigs,
    parseContactType,
} from './configs'
import { get } from './generic'
import { GroupApiData, parseGroup } from './group'
import { MarkApiData, parseMark } from './mark'
import { parsePaymentMethod, PaymentMethodApiData } from './payment'

interface LoadInitialDataInterface {
    configs: ConfigsApiData
    currencies: CoinApiData[]
    user: AccountApiData
    paymentMethods: PaymentMethodApiData[]
    loggedCashier: CashierApiData
    contactTypes: ContactTypeApiData[]
    permissions: RuleApiData[]
    cashiers: CashierApiData[]
    branches: BranchApiData[]
    groups: GroupApiData[]
    brands: MarkApiData[]
    priceList: string[]
}

export async function getLastFrontEndVersion(): Promise<Date> {
    const res = await get('front-version')

    return new Date(res.data.lastUpdate)
}

export async function loadInitialData() {
    const res = await get('utils/initial-data')

    const {
        configs,
        currencies,
        user,
        paymentMethods,
        loggedCashier,
        contactTypes,
        permissions,
        cashiers,
        branches,
        groups,
        brands,
        priceList,
    } = res.data.data as LoadInitialDataInterface

    const rules = permissions.map(parseRule)
    const coins = currencies.map(parseCoin)

    return {
        configs: parseConfigs(configs),
        coins,
        user: parseAccount(user, rules, coins),
        paymentMethods: paymentMethods.map(parsePaymentMethod),
        loggedCashier: loggedCashier ? parseCashier(loggedCashier) : null,
        rules,
        contactTypes: contactTypes.map(parseContactType),
        cashiers: cashiers.map(parseCashier),
        branches: branches.map((branch) => parseBranch(branch, coins, branches)),
        groups: groups.map(parseGroup),
        marks: brands.map(parseMark),
        priceList,
    }
}
